// Replaced at build time by Vite `define` (see vite.config.ts).
declare const __BUILD_VERSION__: string;
declare const __BUILD_DATE__: string;

export const BUILD = {
  version: typeof __BUILD_VERSION__ === 'string' ? __BUILD_VERSION__ : 'dev',
  date: typeof __BUILD_DATE__ === 'string' ? __BUILD_DATE__ : 'dev',
};
